'use client';

import { PhotoArchiveRootFrame } from "@/app/features/sites/photo-archive/ui/shared/PhotoArchiveFrames";
import PhotoArchiveDetailsSectionsEditable
    from "@/app/features/sites/photo-archive/ui/editable/PhotoArchiveDetailsSections.editable";
import PhotoArchiveShowroomEditable from "@/app/features/sites/photo-archive/ui/editable/PhotoArchiveShowroom.editable";
import PhotoArchiveRelatedInfosEditable
    from "@/app/features/sites/photo-archive/ui/editable/PhotoArchiveRelatedInfos.editable";

export default function PhotoArchiveEditable() {
    return (
        <PhotoArchiveRootFrame>
            <PhotoArchiveDetailsSectionsEditable />
            <PhotoArchiveShowroomEditable />
            <PhotoArchiveRelatedInfosEditable />
        </PhotoArchiveRootFrame>
    )
}
